import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../../destroyable.component';
import {Pagination} from '../pagination.component';

@Component({
  selector: 'gp-table-pagination',
  template: `
    <footer class="dker p-a">
      <div class="row">
        <div class="col-sm-12 text-center">
          <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
            <li [ngClass]="{disabled: !pagination.hasPrevious()}" class="page-item">
              <a (click)="pagination.hasPrevious() && pagination.first()" class="page-link">
                <em class="fa fa-light fa-angle-double-left"></em></a>
            </li>
            <li [ngClass]="{disabled: !pagination.hasPrevious()}" class="page-item">
              <a (click)="pagination.hasPrevious() && pagination.previous()" class="page-link">
                <em class="fa fa-light fa-angle-left"></em></a>
            </li>
            <li *ngFor="let page of pagination.pages()" class="page-item"
                [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
              <a *ngIf="page > 0" (click)="pagination.goToPage(page - 1)" class="page-link">{{ page }}</a>
              <a *ngIf="page < 1" class="page-link default-cursor">…</a>
            </li>
            <li [ngClass]="{disabled: (!pagination.hasNext() || pagination.totalItems == 0)}" class="page-item">
              <a (click)="pagination.hasNext() && pagination.next()" class="page-link">
                <em class="fa fa-light fa-angle-right"></em></a>
            </li>
            <li [ngClass]="{disabled: (!pagination.hasNext() || pagination.totalItems == 0)}" class="page-item">
              <a (click)="pagination.hasNext() && pagination.last()" class="page-link">
                <em class="fa fa-light fa-angle-double-right"></em></a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  `
})
export class TablePaginationComponent extends Destroyable implements OnInit {

  @Input()
  public pagination: Pagination;

  @Input()
  public text: string = 'COMMON.pagination';

  @Output()
  public pageChange: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
    super();
  }

  ngOnInit() {
    this.pagination.pageChanged.asObservable()
      .pipe(
        tap(() => this.pageChange?.emit()),
        takeUntil(this.componentDestroyed$)
      ).subscribe();
  }
}
